import { useState, useEffect, useRef, useCallback } from 'react';

export const useSafeState = initialState => {
    const [state, setState] = useState(initialState);
    const isMountedRef = useRef(true);
    
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    
    const safeSetState = useCallback((value) => {
        if (isMountedRef.current) {
            setState(value);
        }
    }, []);
    
    return [state, safeSetState];
};
